
import { defineComponent, onMounted } from 'vue';
import {
    AppFormRow,
    AppInput,
    AppCard,
    AppButton,
    AppSelect,
    AppFileUpload,
    AppImageHolder,
    AppSwitch
} from '@/components';
import { useAvatarDefaultEdit } from '@/modules/avatar/default/model/edit';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.DEFAULT.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppFileUpload, AppImageHolder, AppSwitch },
    setup() {
        const { model, v$, actions, typeList, genderList } = useAvatarDefaultEdit();

        onMounted(() => {
            actions.fetch();
        });

        return { v$, model, actions, typeList, genderList };
    }
});
